import { useCanAssign } from "~/lib/iam/actions/cnspec/policy/PolicyResolver/Assign";
import { useCanSetBundle as useCanSetBundlePolicy } from "~/lib/iam/actions/cnspec/policy/PolicyHub/SetBundle";
import { useCanSetBundle as useCanSetBundleQueryPack } from "~/lib/iam/actions/cnquery/explorer/QueryHub/SetBundle";

export function usePolicyPermissions() {
  const policyAssignPermission = useCanAssign();

  const editPolicyPermission = useCanSetBundlePolicy();

  // If a user has set bundle permission, they also have upload permission
  const policyUploadPermission = editPolicyPermission;

  // If a user has upload permission, they also have delete permission
  const policyDeletePermission = policyUploadPermission;

  // Query Pack's boil down to policies, so we can use the same permissions
  const queryPackAssignPermission = policyAssignPermission;

  const queryPackUploadPermission = useCanSetBundleQueryPack();

  return {
    policyAssignPermission,
    policyUploadPermission,
    policyDeletePermission,
    editPolicyPermission,
    queryPackAssignPermission,
    queryPackUploadPermission,
  };
}
